/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum TipType {
  CASH_ONLY = "CASH_ONLY",
  REQUIRED_TIP = "REQUIRED_TIP",
  TIP = "TIP",
}

export enum UserStatus {
  invited = "invited",
  registered = "registered",
}

export interface AddressInput {
  id?: string | null;
  name?: string | null;
  street1: string;
  city: string;
  state: string;
  zip: string;
  phone?: string | null;
}

export interface FulfillmentCenterInfo {
  name?: string | null;
  menuId?: string | null;
  pickup?: boolean | null;
  delivery?: boolean | null;
  deliveryText?: string | null;
  disabled?: boolean | null;
  deliveryConfigurationId?: string | null;
}

export interface InviteInput {
  roleId: string;
  firstName: string;
  lastName: string;
  email: string;
  venueId?: number | null;
  venueOperatorId?: number | null;
}

export interface ItemInput {
  name?: string | null;
  alcoholServings?: number | null;
  image?: any | null;
  description?: string | null;
  additionalComments?: boolean | null;
  taxIds?: string[] | null;
}

export interface MenuCategoryInput {
  id?: string | null;
  name: string;
  salesCategoryId: string;
}

export interface MenuItemInput {
  price: number;
  countsTowardMinimum?: boolean | null;
  item?: ItemInput | null;
  enabled?: boolean | null;
  featured?: boolean | null;
  optionGroups?: MenuOptionGroupInput[] | null;
  taxable?: boolean | null;
}

export interface MenuOptionGroupInput {
  id: string;
  options: MenuOptionInput[];
}

export interface MenuOptionInput {
  id?: string | null;
  price?: number | null;
  enabled?: boolean | null;
  option: OptionInput;
}

export interface OptionInput {
  id?: string | null;
  name?: string | null;
}

export interface PaymentInfo {
  routingNumber: string;
  accountNumber: string;
  taxId: string;
}

export interface PaymentInfoInput {
  descriptor: string;
  routingNumber: string;
  accountNumber: string;
  taxId: string;
}

export interface SquareConfigInput {
  primaryLocationId?: string | null;
  menuLocationIds?: string[] | null;
  menuId?: string | null;
}

export interface VenueInput {
  name?: string | null;
  address?: AddressInput | null;
  businessAddress?: AddressInput | null;
  ownerAddress?: AddressInput | null;
  paymentAddress?: AddressInput | null;
  merchantId?: string | null;
  paymentProcessor?: string | null;
  businessRegistrationNumber?: string | null;
  liquorLicense?: string | null;
  itin?: string | null;
  ownerDOB?: string | null;
  image?: any | null;
  config?: any | null;
  paymentInfo?: PaymentInfoInput | null;
  salesTaxPercentage?: number | null;
  requiredTipPercentage?: number | null;
  tipPolicy?: TipType | null;
  squareConfig?: SquareConfigInput | null;
  pointOfContactFirstName?: string | null;
  pointOfContactLastName?: string | null;
}

export interface VenueInviteInput {
  name: string;
  pointOfContactEmail: string;
  address: AddressInput;
  businessAddress: AddressInput;
  ownerAddress: AddressInput;
  paymentAddress?: AddressInput | null;
  pointOfContactFirstName: string;
  pointOfContactLastName: string;
  businessRegistrationNumber?: string | null;
  liquorLicense?: string | null;
  itin?: string | null;
  paymentProcessor: string;
  ownerDOB?: string | null;
  paymentInfo?: PaymentInfo | null;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
